<mat-card *kienePermission="[3411]">
    <h5>Rabattstaffeln</h5>
    <table>
        <thead style="font-size: 0.8em; color: #aaa">
            <tr>
                <th style="text-align: left">Ab</th>
                <th style="text-align: left">Rabatt</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let rs of rabattstaffeln; let i = index">
                <td [attr.data-cy]="'mrsrs_td_1_5_' + i">{{ rs.artikelmenge_ab }} Stk.</td>
                <td [attr.data-cy]="'mrsrs_td_2_5_' + i">{{ rs.rabatt }} %</td>
                <td [attr.data-cy]="'mrsrs_td_3_5_' + i"
                    ><button mat-icon-button (click)="remove(rs)" [attr.data-cy]="'mrsrs_button_1_0_' + i">
                        <mat-icon [attr.data-cy]="'mrsrs_mat-icon_1_2_' + i">delete</mat-icon>
                    </button></td
                >
            </tr>
            <tr>
                <td style="width: 60px" [attr.data-cy]="'mrsrs_td_4_5_'">
                    <mat-form-field>
                        <input
                            matInput
                            type="number"
                            [formControl]="amountCtrl"
                            placeholder="Menge"
                            [attr.data-cy]="'mrsrs_input_1_1_'"
                        />
                    </mat-form-field>
                </td>
                <td style="width: 60px" [attr.data-cy]="'mrsrs_td_5_5_'">
                    <mat-form-field>
                        <input
                            matInput
                            type="number"
                            [formControl]="rabattCtrl"
                            placeholder="Rabatt in %"
                            [attr.data-cy]="'mrsrs_input_2_1_'"
                        />
                    </mat-form-field>
                </td>
                <td [attr.data-cy]="'mrsrs_td_6_5_'">
                    <button
                        *kienePermission="[3411]"
                        mat-icon-button
                        (click)="save()"
                        color="primary"
                        [disabled]="material.artikel_id === null || material.artikel_id === undefined"
                        [attr.data-cy]="'mrsrs_button_2_0_'"
                    >
                        <mat-icon [attr.data-cy]="'mrsrs_mat-icon_2_2_'">add_circle_outline</mat-icon>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</mat-card>
